import React, { memo } from 'react'
import { Handle, Position, type NodeProps } from 'reactflow'
import { nodeCardClass, nodeChipClass, nodeHandleClass, nodeIcon, nodeTextClass } from '../../nodeCatalog'

const TYPE = 'crmSync'
const Icon = nodeIcon(TYPE)

const CRM_LABELS: Record<string, string> = {
  hubspot: 'HubSpot',
  pipedrive: 'Pipedrive',
  salesforce: 'Salesforce',
}

const CrmSyncNode: React.FC<NodeProps> = ({ data, selected }) => {
  const provider = data.crm_sync_config?.provider || 'hubspot'
  return (
    <div className={nodeCardClass(TYPE, selected)}>
      <Handle type="target" position={Position.Top} className={nodeHandleClass(TYPE)} />
      <div className="flex items-center gap-2">
        <div className={nodeChipClass(TYPE)}>
          <Icon className={`w-4 h-4 ${nodeTextClass(TYPE)}`} />
        </div>
        <div className="flex-1 min-w-0">
          <p className={`text-[10px] font-emphasis uppercase tracking-wider ${nodeTextClass(TYPE)}`}>CRM Sync</p>
          <p className="text-sm font-medium text-foreground truncate">{data.label || 'CRM Sync'}</p>
        </div>
      </div>
      <p className="mt-1 text-xs text-muted-foreground pl-10">
        {CRM_LABELS[provider] || provider}{data.crm_sync_config?.create_deal ? ' + Deal' : ''}
      </p>
      <Handle type="source" position={Position.Bottom} className={nodeHandleClass(TYPE)} />
    </div>
  )
}

export default memo(CrmSyncNode)
